module.exports = __webpack_public_path__ + "img/Spinner-1s-204px.276b3819.svg";